import type { Config } from './types';

export const defaultFilterConfig: Config = {
  ignoreCase: true,
  ignoreAccents: false,
  trim: false,
  matchFrom: 'start',
};
